skyward.base.registerScript("studentonlineassignment", function (skyward, $) {

    function studentTimerInit() {
        var selector = $(this);
        const timerData = {};
        var assignmentTimerInterval;
        var dynamicNavigator = getDynamicNavigator(selector);

        var data = selector.data();
        timerData.StudentAssignmentID = data.studentassignmentid;
        timerData.StudentAssignmentIDHash = data.studentassignmentidhash;
        timerData.InProgress = data.inprogress != "False";
        timerData.DisplayingRedBanner = dynamicNavigator.find('.cmaMessageArea').hasClass('cmaErrorMessage');

        if (dynamicNavigator.length > 0) {
            dynamicNavigator.on('dynamicNavigatorButtonClick', '.dynamicNavigatorStepButton', checkSetTimer);

            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            setTimerStyles.apply(cmaMessageArea);

            if (timerData.InProgress)
            {
                checkAssignmentEndTime();
            }
            else
            {
                // If displaying from instructions screen and the assignment hasn't started yet.
                cmaMessageArea.addClass('cmaWarningMessage');
            }
        }

        function checkSetTimer()
        {
            if (timerData.InProgress !== true)
            {
                startTimer.apply($(this));
            }
            
            checkAssignmentEndTime();
            
        };

        function startTimer()
        {
            var selector = $(this);
            var dynamicNavigator = getDynamicNavigator(selector);

            if (dynamicNavigator.length > 0)
            {
                var timerElement = dynamicNavigator.find('.js-studentAssignmentTimer').first();

                setTimerStatus(timerElement, true);
            }
        }

        var setTimerStatus = function (timerElement, inProgress)
        {
            timerElement.data('inprogress', inProgress);
            timerData.InProgress = inProgress
        }

        function checkAssignmentEndTime() {
           
            let studentAssignmentID = timerData.StudentAssignmentID;
            if (studentAssignmentID != null) {
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/StudentQuestion/GetStudentAssignmentEndTime",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentAssignmentID: studentAssignmentID,
                        studentAssignmentIDHash: timerData.StudentAssignmentIDHash
                    },
                    success: function (data) {
                        if (data.endTime) {
                            var endTime = new Date(data.endTime);

                            if (endTime <= skyward.time.now()) {
                                clearInterval(assignmentTimerInterval);
                                handleTimerExpiration();
                            }
                            else {
                                clearInterval(assignmentTimerInterval); // Needs to be cleared since we'll hit this everytime a question loads when stepping through the navigator.
                                updateAssignmentTimer(endTime);
                                assignmentTimerInterval = setInterval(updateAssignmentTimer, 1000, endTime, studentAssignmentID)
                            }
                        }
                    }
                });
            }
        };

        function updateAssignmentTimer(endTime) {
            var currentTime = skyward.time.now();
            const timeDefault = '00';
            const timeRemainingToStartShowingRedBanner = 301000; // in ms
            var hours = timeDefault;
            var minutes = timeDefault;
            var seconds = timeDefault;

            var timeRemaining = endTime - currentTime;
            if (!isNaN(timeRemaining) && timeRemaining >= 0) {
                var hours = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                var minutes = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)));
                var seconds = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60)) / 1000));
            }

            if (timeRemaining <= 0 || isNaN(timeRemaining)) {
                clearInterval(assignmentTimerInterval);
                handleTimerExpiration();
            }

            if (!timerData.DisplayingRedBanner && timeRemaining > 0 && timeRemaining < timeRemainingToStartShowingRedBanner)
            {
                setRedBannerOnTimer();
                clearInterval(assignmentTimerInterval);
                checkAssignmentEndTime();
            }

            $('.dynamicNavigatorWrapper').find('.cmaMessageText').text('Time Remaining: ' + hours + ':' + minutes + ':' + seconds);
        };

        function getFormattedNumberForTime (num) {
            return num.toLocaleString('en-US', { minimumIntegerDigits: 2 });
        }

        function handleTimerExpiration() {

            let data = getQuestionValues();
            data.studentAssignmentID = timerData.StudentAssignmentID;
            data.studentAssignmentIDHash = timerData.StudentAssignmentIDHash;

            var studentQuestionWrapper = dynamicNavigator.find('.QuestionDisplayableWrapper').first();
            data.studentQuestionID = studentQuestionWrapper.data('student-question-id');
            data.studentQuestionIDHash = studentQuestionWrapper.data('student-question-id-hash');

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentQuestion/TimedStudentAssignmentExpired",
                type: "POST",
                dataType: "JSON",
                data: data
            }).always(function () {
                skyward.changeTracking.clearDirtyList();
                skyward.window.loadContent("full", "Gradebook", "StudentQuestion", "TimedStudentAssignmentExpiredRedirect", data.studentAssignmentID);
            });
        }

        function setTimerStyles() {
            var selector = $(this);
            selector.off(); // prevent popup
            selector.removeClass('pointer');
            selector.children().removeClass('pointer'); // remove mouse hover style
        }

        function setRedBannerOnTimer()
        {
            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            cmaMessageArea.removeClass('cmaWarningMessage');
            cmaMessageArea.addClass('cmaErrorMessage');
            timerData.DisplayingRedBanner = true;
        }

        function getQuestionValues() {
            var values = {};

            dynamicNavigator.find("[name]").not(".doNotPost").each(function () {
                var field = $(this);

                var name = field.attr("name");

                if (name == "") {
                    return;
                }
                var value = skyward.controls.getValue(field);
                values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
            });

            return values;
        }
    };

 
    function getDynamicNavigator(selector) {
        return $(selector).parents('.js-studentAssignmentNavigator').first();
    }

    var events =
    {
        "studentTimerInit": studentTimerInit
    };

    return events;
});